import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  createLayoutSegmentCaptionOverrideSelector,
  createLayoutSegmentSubjectsSelector,
  videoDimensionsSelector,
} from 'redux/modules/embed/selectors';
import { ScenePreset } from 'types';
import useEditSceneModal from '../useEditSceneModal';
import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

export default function useSelectPreset() {
  const {
    dispatch,
    state: { selectedPreset },
  } = useEditSceneModalStateContext();

  const { segmentId, videoId } = useEditSceneModal();

  const videoDimensions = useSelector(videoDimensionsSelector(videoId));
  const subjects = useSelector(
    createLayoutSegmentSubjectsSelector(videoId, segmentId),
  );

  const captionsOverride = useSelector(
    createLayoutSegmentCaptionOverrideSelector(videoId, segmentId),
  );

  return {
    selectedPreset,
    selectPreset: useCallback(
      (preset: ScenePreset) => {
        dispatch({
          type: 'select-preset',
          payload: {
            captionsOverride,
            preset,
            subjects,
            videoDimensions,
          },
        });
      },
      [captionsOverride, dispatch, subjects, videoDimensions],
    ),
  };
}
